function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { createContext, useContext, useMemo } from 'react';
import { isArray, isFunction } from '@okee-uikit/react-utils';
import { useRefCallback } from '@okee-uikit/react-hooks';

function getRowInfos(data, getId, getChildren, level, parentPath, parentSerials, getProps) {
  return data.map(function (row, index) {
    var serials = [].concat(_toConsumableArray(parentSerials), [index]);
    var id = getId(row, index);
    var path = [].concat(_toConsumableArray(parentPath), [id]);
    var rowChildren = getChildren(row, index);
    var children = isArray(rowChildren) && getRowInfos(rowChildren, getId, getChildren, level + 1, path, serials, getProps) || undefined;
    var isLeaf = !children;
    return {
      row: row,
      id: id,
      path: path,
      index: index,
      serials: serials,
      level: level,
      isLeaf: isLeaf,
      children: children,
      compProps: getProps === null || getProps === void 0 ? void 0 : getProps(row)
    };
  });
}

export function useTableRowsInit(data, options, selectOptions) {
  var _ref = selectOptions || {},
      componentProps = _ref.componentProps;

  var getProps = useRefCallback(isFunction(componentProps) && componentProps || function () {
    return componentProps;
  });
  var getId = options.getId,
      getChildren = options.getChildren;
  return useMemo(function () {
    return getRowInfos(data, getId, getChildren, 1, [], [], getProps);
  }, [data, getId, getChildren, componentProps]);
}
export var RowsContext = createContext({
  original: [],
  current: []
});
export var useTableRows = function useTableRows() {
  return useContext(RowsContext);
};